export class Quota {
  id?: string;
  name: string;
  target: number;
  audienceId?: string;
  conditions: QuotaCondition[];
}

export type Command = 'AND' | 'OR';

export interface QuotaCondition {
  sourceId: string;
  optionId: string;
  command: Command;
}
